import api from '~/services/api';
import { ProdutoProps } from '../../types';

const getProdutoGtin = async (
  cod_loja: number,
  cod_gtin: string,
): Promise<ProdutoProps | boolean> => {
  const { data } = await api.get<ProdutoProps | boolean>(
    `/busca-produto/${cod_loja}/${cod_gtin}`,
  );
  return data;
};

export const produtoService = { getProdutoGtin };
